import type { ComponentProps, MouseEvent } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from '../../../application/hooks/useTranslation';
import { usePaymentLock } from '../../../application/hooks/usePaymentLock';

/** Drop-in `Link` for installment pay entry points: renders a disabled, explained control while the booking is unverified. */
export function PayLink({ to, children, className, onClick, style, ...rest }: ComponentProps<typeof Link>) {
  const { t } = useTranslation();
  const { locked } = usePaymentLock();
  if (!locked) return <Link to={to} className={className} onClick={onClick} style={style} {...rest}>{children}</Link>;
  return (
    <span
      role="link"
      aria-disabled="true"
      tabIndex={0}
      title={t('payments.locked.short')}
      className={`${className ?? ''} pay-locked`.trim()}
      style={style}
      onClick={(e: MouseEvent) => e.preventDefault()}
      data-testid={(rest as { 'data-testid'?: string })['data-testid'] ?? 'pay-locked'}
      data-pay-locked="true"
    >
      {children}
    </span>
  );
}
